/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_onboarding_activate_card_benefit_2 = /** @type {(inputs: {}) => string} */ () => {
	return `Transacciones en múltiples monedas`
};

const en_onboarding_activate_card_benefit_2 = /** @type {(inputs: {}) => string} */ () => {
	return `Transactions in multiple currencies`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const onboarding_activate_card_benefit_2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.onboarding_activate_card_benefit_2(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("onboarding_activate_card_benefit_2", locale)
	if (locale === "es") return es_onboarding_activate_card_benefit_2(inputs)
	return en_onboarding_activate_card_benefit_2(inputs)
};
export { onboarding_activate_card_benefit_2 as "onboarding.activate_card.benefit_2" }